// var object = require('lodash/fp/object');
import nanoScroller from '@global/vendors/jquery.nanoscroller.min';
import Vue from 'vue';
import cartNotification from '@global/components/cart/cartNotification';
import AlertDialog from '@global/helpers/alertDialog';
import messageBox from '@global/helpers/messageBox';
import modal from 'bootstrap/js/dist/modal';
import validate from '@global/vendors/jquery.validate.min';
import Collapse from 'bootstrap/js/dist/collapse';
import NewImage from '@global/components/global/image';
import store from '@global/components/store/index';
import { createNamespacedHelpers } from 'vuex';
import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';
import $ from 'jquery';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('miniCartModule');

global.$ = global.jQuery = require('jquery'); // fix can't use JQ in inline script

if ($('#app-mini-cart').length > 0) {
  window.appNotificationCart = new Vue({
    el: '#app-mini-cart',
    store,
    components: { NewImage },
    data() {
      return {
        reference: '',
      };
    },
    computed: {
      ...mapState([
        'totalCount',
        'generalCount',
        'refrigerationCount',
        'freezingCount',
        'dataIsLoad',
        'generalMarketProducts',
        'count',
        'hotSearch',
        'hotLoad',
      ]),
      ...mapGetters(['isOnlyOneTemp']),
    },
    watch: {
      hotLoad(value) {
        if (value && window.location.pathname.includes('search')) {
          fireSearchListEvent(this.hotSearch);
        }
      },
    },
    created() {
      this.getCartInfo();
      this.getHotSearch();
    },
    mounted() {
      this.reference = window.location.href;
    },
    methods: {
      ...mapActions(['getCartInfo', 'getHotSearch']),
      changeCurrency(chose) {
        // 幣別語系暫時做在一起
        const fromCurrencyInput = document.querySelector('#from-currency input[name="cr"]');
        if (fromCurrencyInput) {
          fromCurrencyInput.value = chose;
        }

        document.getElementById('from-currency').submit();
      },
      customCount(count) {
        if (count < 10) {
          return `0${count.toString()}`;
        }
        return count.toString();
      },
      goSearch(item) {
        window.location.href = `/search?Keyword=${item}`;
        fireSearchEvent({
          isHotSearch: true,
          keyword: item,
        });
      },
      spread() {
        $('.hot-input-block').addClass('open');
        $('.hot-cancel').css('display', 'inline-block');
      },
    },
  });
}
const burgerAPP = new Vue({
  data() {
    return {
      reference: '',
    };
  },
  mounted() {
    this.reference = window.location.href;
  },
  methods: {
    changeCurrency(chose) {
      // 幣別語系暫時做在一起
      const fromCurrencyInput = document.querySelector('#from-currency-mb input[name="cr"]');
      if (fromCurrencyInput) {
        fromCurrencyInput.value = chose;
      }

      document.getElementById('from-currency-mb').submit();
    },
  },
});

// fix when mutiple inputs with same name always validate the first item.
$.validator.prototype.checkForm = function () {
  // overriden in a specific page
  this.prepareForm();
  for (let i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++) {
    if (
      this.findByName(elements[i].name).length !== undefined &&
      this.findByName(elements[i].name).length > 1
    ) {
      for (let cnt = 0; cnt < this.findByName(elements[i].name).length; cnt++) {
        this.check(this.findByName(elements[i].name)[cnt]);
      }
    } else {
      this.check(elements[i]);
    }
  }
  return this.valid();
};

// 電子報
const mailValidate = {
  errorClass: 'error',
  errorElement: 'div',
  rules: {
    newsletter: {
      required: true,
      email: true,
    },
  },
  messages: {},
  errorPlacement(error, element) {
    element.parent().append(error);
  },
  submitHandler(form) {
    const $input = $(form).find('.input-newsletter');
    $.ajax({
      type: 'POST',
      url: '/api/v1/Subscribe/Apply',
      dataType: 'json',
      data: { Email: $input.val() },
      xhrFields: {
        withCredentials: false,
      },
      error(error) {
        AlertDialog.alertBear(error.Message);
      },
      success(res) {
        AlertDialog.alertBear(res.Message, function () {});
      },
    });
  },
};
$('#form-newsletter-signup').validate(mailValidate);
$('#form-newsletter-signup-mobile').validate(mailValidate);

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.Vue = Vue;
window.messageBox = messageBox;

$('body').on('click', '.open-sidebar', function (e) {
  e.preventDefault();
  const $el = $(this);
  const target = $el.data('sidebar');
  const mask = $el.data('mask');
  $(target).toggleClass('active');
  $el.toggleClass('active');
  $(mask).toggleClass('active');
  if ($el.hasClass('active')) {
    $('body').addClass('lock-page');
  } else {
    $('body').removeClass('lock-page');
  }
});

$('body').on('click', '.close-sidebar', function (e) {
  e.preventDefault();
  var $el = $(this),
    target = $el.data('sidebar'),
    mask = $el.data('mask'),
    btn = $el.data('btn');
  $(target).removeClass('active');
  $(mask).removeClass('active');
  $(btn).removeClass('active');
  $('body').removeClass('lock-page');
});

$('.btn-global-search').click(function (e) {
  e.preventDefault();
  $('.popular-list').addClass('d-block');
  $('.currency-group').addClass('hide');
  $('.hide-search').addClass('hide');
  $('.search-form').addClass('active');
  $('.member-nav').addClass('active');
  $('#search-input').get(0).focus();
  $('#search-mask').addClass('active');
});

$('body').on('click', '#search-mask', function (e) {
  e.preventDefault();
  $('.popular-list').removeClass('d-block');
  $('.currency-group').removeClass('hide');
  $('.hide-search').removeClass('hide');
  $('.currency-group').removeClass('hide');
  $('.search-form').removeClass('active');
  $('.member-nav').removeClass('active');
  $('#search-popup').removeClass('active');
  $('#search-mask').removeClass('active');
});

$('.btn-global-search-mobile').click(function (e) {
  e.preventDefault();
  $('.mobile-search-block .search-form').addClass('active');
  $('#search-popup').addClass('active');
  $('#search-input-m').get(0).focus();
});

$('body').on('click', '.mobile-search-mask', function (e) {
  e.preventDefault();
  $('.currency-group').removeClass('hide');
  $('.hide-search').removeClass('hide');
  $('.search-form').removeClass('active');
  $('.member-nav').removeClass('active');
  $('#search-popup').removeClass('active');
});

const $btnTop = $('#top-btn');

$btnTop.click(function (e) {
  e.preventDefault();
  $('html,body').animate({ scrollTop: 0 }, 300);
  return false;
});

// search
const gotosearch = function (inputVal) {
  if (inputVal === '') {
    AlertDialog.alertBear('請輸入關鍵字');
  } else {
    window.location.href = '/search?Keyword=' + inputVal;
    fireSearchEvent({
      isHotSearch: false,
      keyword: inputVal,
    });
  }
};

$('#form-global-search').on('submit', function (event) {
  event.preventDefault();
  gotosearch($(this).find('input').val());
});

$('.btn-search-m').click(function (event) {
  event.preventDefault();
  gotosearch($(this).parents('form').find('input').val());
});

setTimeout(() => {
  $('#accordion').append(
    `<li class="panel product-list">
      <a href="#" data-target="#lb-language" data-toggle="modal">
        <i class="icon-global-dark"></i> Language
      </a>
    </li>`,
  );
}, 100);
